import * as affiliateLocator from './affiliatelocator';
import * as autoApplyPromoLocator from './autoapplypromolocator';

export function handleLocator(locator, urlSearchParams) {
    const value = urlSearchParams.get(locator.params.find(key => urlSearchParams.has(key)));

    if (value) {
        locator.handler(value, urlSearchParams);
    }
}

export default function discover(search, { allowAutoApplyPromo }) {
    const params = new URLSearchParams(search);
    const locators = [affiliateLocator];

    if (allowAutoApplyPromo) {
        locators.push(autoApplyPromoLocator);
    }

    locators.forEach(locator => handleLocator(locator, params));
}